import { capitalizeFirstWord } from './capitalizedFunc';

export const toggleFieldEnabled = (isEnabled, setIsEnabled, sections, setSections, sectionArray, sectionId, index) => {
    setIsEnabled(!isEnabled);
    const updatedFields = sectionArray.fields.map((el, i) =>
        i === index ? { ...el, is_enabled: !isEnabled } : el
    );
    const updatedSections = sections.map((el) =>
        el.id === sectionId ? { ...el, fields: updatedFields } : el
    );
    setSections(updatedSections);
};

export const isRequiredFieldChange = (event, sectionArray, index, sections, sectionId, setSections) => {
    const updatedFields = sectionArray.fields.map((el, i) =>
        i === index ? { ...el, is_required: event.target.checked } : el
    );
    const updatedSections = sections.map((el) =>
        el.id === sectionId ? { ...el, fields: updatedFields } : el
    );
    setSections(updatedSections);
};

export const lableFieldChange = (event, sectionArray, index, sections, sectionId, setSections) => {
    const updatedFields = sectionArray.fields.map((el, i) =>
        i === index ? { ...el, label: event.target.value } : el
    );
    const updatedSections = sections.map((el) =>
        el.id === sectionId ? { ...el, fields: updatedFields } : el
    );
    setSections(updatedSections);
};

export const descriptionFieldChange = (event, sectionArray, index, sections, sectionId, setSections) => {
    const updatedFields = sectionArray.fields.map((el, i) =>
        i === index ? { ...el, description: event.target.value } : el
    );
    const updatedSections = sections.map((el) =>
        el.id === sectionId ? { ...el, fields: updatedFields } : el
    );
    setSections(updatedSections);
};

export const attrFieldChange = (event, sectionArray, index, sections, sectionId, setSections) => {
    const updatedFields = sectionArray.fields.map((el, i) =>
        i === index ? { ...el, attribute: event.target.value } : el
    );
    const updatedSections = sections.map((el) =>
        el.id === sectionId ? { ...el, fields: updatedFields } : el
    );
    setSections(updatedSections);
};

export const getTooltipTitle = (category) => {
    switch (category) {
        case 'INBOUND':
            return `${capitalizeFirstWord(category)} (Lead -> CRM)`;
        case 'OUTBOUND':
            return `${capitalizeFirstWord(category)} (CRM -> Lead)`;
        default:
            return capitalizeFirstWord(category);
    }
};


// Task #29 Defect 5: use the LeadTreatment id (v2Data.id) instead of the array
// index so the composite key is stable across page changes and unique for multi-
// treatment leads. e.g. "42-17" instead of "42-0". The `index` param is retained
// as a fallback for any callers that don't supply the treatment id (v2Data.id).
// useLeadTableHelper:113 extracts the numeric lead id via split("-")[0] — that is
// unchanged: "42-17".split("-")[0] === "42" as expected.
//
// RCG-2 shape guard: parseV2ToV1 previously assumed every input was a v2
// lead-treatment object with a nested `.lead`. Two other shapes reach this
// function in practice and both produced corrupted output:
//   - a LEAD-shaped object (top-level lead_treatments[], no nested `.lead`) —
//     re-wrapping it emitted id `"undefined-<id>"` and NaN lead ids. It is
//     already v1-shaped, so we pass it through unchanged.
//   - a non-object (null/undefined/string/number/array) — return a safe empty
//     lead instead of emitting "undefined-…" ids.
// The v2 lead-treatment branch below also now guards treatment_data to be an
// object (or null) so a bare string `treatment` (e.g. "Invisalign") never
// leaks through as treatment_data — downstream `Object.keys(treatment_data)`
// must never see per-character digit keys.
export const parseV2ToV1 = (v2Data, index) => {
    // Non-object input: never emit "undefined-…" ids.
    if (!v2Data || typeof v2Data !== 'object' || Array.isArray(v2Data)) {
        return { id: null, lead_treatments: [] };
    }

    // Already v1 lead-shaped (top-level lead_treatments[], no nested .lead):
    // re-parsing would double-wrap it and emit "undefined-<id>". Pass through.
    if (Array.isArray(v2Data.lead_treatments) && v2Data.lead == null) {
        return v2Data;
    }

    const leadId = v2Data?.lead?.id;
    if (leadId == null) {
        // No genuine nested lead id — reject as a safe, filterable empty row.
        // NEVER fabricate a lead id from the lead_treatment id (v2Data.id) or the array index.
        return { id: null, lead_treatments: [] };
    }

    const t = v2Data?.treatment;
    const isTreatmentObject = t && typeof t === 'object' && !Array.isArray(t);
    const isTreatmentString = typeof t === 'string';
    const treatmentData = isTreatmentObject ? t : null;
    let treatmentName;
    if (isTreatmentObject) treatmentName = t?.treatment_item?.name;
    else if (isTreatmentString) treatmentName = t;
    else treatmentName = undefined;

    return {
        ...v2Data?.lead,
        id: `${leadId}-${v2Data?.id ?? index}`,
        lead_treatments: [{
            ...v2Data,
            lead: leadId,
            treatment_data: treatmentData,
            treatment: treatmentName,
        }],
    };
};